import ArticleDetail from "CMS/Article/App";
import ArticleList from "CMS/ArticleList/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const articleRoute: RouteObject = {
  path: "article",
  children: [{
    path: ":section",
    loader: () => viewModel,
    Component: ArticleList,
  }, {
    path: ":key/edit",
    loader: () => viewModel,
    Component: ArticleDetail,
  }]
};